var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 7.9999H20C20.5304 7.9999 21.0391 8.21062 21.4142 8.58569C21.7893 8.96076 22 9.46947 22 9.9999V12.1039C22.0003 12.3653 21.9493 12.6241 21.85 12.8659L18.755 20.3809C18.6795 20.5641 18.5513 20.7208 18.3866 20.831C18.2219 20.9412 18.0282 21 17.83 20.9999H1C0.734784 20.9999 0.48043 20.8945 0.292893 20.707C0.105357 20.5195 0 20.2651 0 19.9999V9.9999C0 9.73469 0.105357 9.48033 0.292893 9.2928C0.48043 9.10526 0.734784 8.9999 1 8.9999H4.482C4.6421 8.99994 4.79986 8.96155 4.94203 8.88794C5.0842 8.81433 5.20662 8.70766 5.299 8.5769L10.752 0.849904C10.8209 0.752217 10.9226 0.682464 11.0385 0.653294C11.1545 0.624124 11.277 0.637467 11.384 0.690904L13.198 1.5979C13.7085 1.85307 14.1163 2.27522 14.3537 2.79422C14.5911 3.31322 14.6438 3.89783 14.503 4.4509L13.6 7.9999ZM6 10.5879V18.9999H17.16L20 12.1039V9.9999H13.6C13.2954 9.99986 12.9948 9.93024 12.7212 9.79636C12.4476 9.66248 12.2082 9.46787 12.0213 9.22739C11.8343 8.98691 11.7048 8.7069 11.6425 8.40873C11.5803 8.11056 11.5869 7.80211 11.662 7.5069L12.565 3.9589C12.5933 3.84823 12.5828 3.73122 12.5353 3.62733C12.4878 3.52345 12.4062 3.43895 12.304 3.3879L11.643 3.0579L6.933 9.7299C6.683 10.0839 6.363 10.3739 6 10.5879ZM4 10.9999H2V18.9999H4V10.9999Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/like.afe8d4b854c1ba942d8de2c4d6ba3ca9.svg";